import { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import Loading from '../../Loading';
import Header from './Header';
import { ToastContainer, toast } from 'react-toastify';
// import { documentFiscal } from '../../features/dashboard/DocumentSlice'
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import gregorian from "react-date-object/calendars/gregorian"
import persian_fa from "react-date-object/locales/persian_fa"
import gregorian_en from "react-date-object/locales/gregorian_en"
import Broadcast from "./Broadcast";
import axios from 'axios';
import $ from 'jquery'
import { host } from "../../function/api";

function DocumentEdit() {
    const id = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()


    const [RahpardaznetFiscalDate, setRahpardaznetFiscalDate] = useState({})
    const [rk_print_green_document, setRk_print_green_document] = useState('')
    const [rk_delivery_green_document, setRk_delivery_green_document] = useState('')
    const [rk_settled_document, setRk_settled_document] = useState('')
    const [rk_description, setRk_description] = useState('')
    const [loading, setLoading] = useState('')
    
  

    const token = localStorage.getItem('token')

    const convert_date = (date, format = 'YYYY/MM/DD') => {
        let object = { date, format }        
        setRahpardaznetFiscalDate(new DateObject(object).convert(persian, persian_fa).format(format))
    }


    const documentUpdateHandler = async (event) => {
        event.preventDefault()
       
        setLoading('1');
        const data = {
            'document_id': id.id,
            'fiscal_date': RahpardaznetFiscalDate.date ? RahpardaznetFiscalDate.date : RahpardaznetFiscalDate,
            'print_status': rk_print_green_document,
            'delivery_status': rk_delivery_green_document,
            'settled': rk_settled_document,
            'description': rk_description,
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/fiscal/update`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (response.data.status == true) {
                toast.success("بخش مالی سند با موفقیت بروزرسانی شد.", {
                    position: "top-center",
                    autoClose: 1500,
                })

            }
         

        } catch (error) {
            if (error.response.data.error) {
                const listError = error.response.data.error;
                $.each(listError, function (index, value) {
                    if (typeof (value) == 'object') {
                        toast.error(value[0], {
                            position: "top-center",
                            autoClose: 5000,
                        })
                    } else {
                        toast.error(value, {
                            position: "top-center",
                            autoClose: 5000,
                        })
                    }
                });
            }

        }

        setLoading('0');
    }

    const documentGetData = async (event) => {


        setLoading('1');

        const data = {
            'document_id': id.id,
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/fiscal`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (response.data.status == true) {
                if(typeof response.data.data == 'object'){
                    if(response.data.data.date != null){
                        setRahpardaznetFiscalDate({'date': response.data.data.date});
                    }
                    
                    setRk_print_green_document(response.data.data.print_status == '1' ? true : false);
                    setRk_delivery_green_document(response.data.data.delivery_status == '1' ? true : false);
                    setRk_settled_document(response.data.data.settled == '1' ? true : false);
                    setRk_description(response.data.data.description);
                }
               
            }

        } catch (error) {
            if (error.response.data.error) {
                const listError = error.response.data.error;
                $.each(listError, function (index, value) {
                    if (typeof (value) == 'object') {
                        toast.error(value[0], {
                            position: "top-center",
                            autoClose: 5000,
                        })
                    } else {
                        toast.error(value, {
                            position: "top-center",
                            autoClose: 5000,
                        })
                    }
                });
            }

        }
        setLoading('0');

    }



    useEffect(() => {
        documentGetData();
    }, [id])


    return (
        <>
            {loading == '1' ? <Loading /> : null}
            <Broadcast title="بخش مالی" />
            {
                (true || typeof document === 'object') ? (
                    (true || Object.keys(document).length != 0 && success === true) ? (
                        <>

                            <div className='row rahpardaznet-cart my-5 print-position'>
                                <div className="col-12 input-100 mb-3 pb-2 rahpardaznet-border-bottom">
                                    <label>تاریخ: </label>
                                    <DatePicker
                                        tabIndex="1"
                                        calendar={persian}
                                        locale={persian_fa}
                                        calendarPosition="bottom-right"
                                        value={RahpardaznetFiscalDate.date ? RahpardaznetFiscalDate.date : RahpardaznetFiscalDate}
                                        onChange={convert_date}
                                        id="fiscal-date"
                                    />
                                </div>
                                <div className="col-12 input-100 mb-3 pb-2 rahpardaznet-border-bottom">
                                    <div className="form-check">
                                        <input className="form-check-input"
                                            type="checkbox" value=""
                                            id="rahpardaznet-print"
                                            checked={rk_print_green_document ? 'checked' : null}
                                            onChange={(e) => setRk_print_green_document(e.target.checked)} />
                                        {
                                            (rk_print_green_document == true) ? (
                                                <label
                                                    className="form-check-label text-success"
                                                    htmlhtmlFor="rahpardaznet-print">سند سبز چاپ شد.</label>

                                            ) : (
                                                <label
                                                    className="form-check-label text-danger"
                                                    htmlhtmlFor="rahpardaznet-print">سند سبز چاپ نشده است.</label>

                                            )
                                        }
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input"
                                            type="checkbox" value=""
                                            id="rahpardaznet-delivery"
                                            checked={rk_delivery_green_document ? 'checked' : null}
                                            onChange={(e) => setRk_delivery_green_document(e.target.checked)} />
                                        {
                                            (rk_delivery_green_document == true) ? (
                                                <label
                                                    className="form-check-label text-success"
                                                    htmlhtmlFor="rahpardaznet-delivery">سند سبز تحویل داده شد.</label>

                                            ) : (
                                                <label
                                                    className="form-check-label text-danger"
                                                    htmlhtmlFor="rahpardaznet-delivery">سند سبز تحویل داده نشد.</label>

                                            )
                                        }
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input"
                                            type="checkbox" value=""
                                            id="rahpardaznet-settled"
                                            checked={rk_settled_document ? 'checked' : null}
                                            onChange={(e) => setRk_settled_document(e.target.checked)} />
                                        {
                                            (rk_settled_document == true) ? (
                                                <label
                                                    className="form-check-label text-success"
                                                    htmlhtmlFor="rahpardaznet-settled">تسویه شد.</label>

                                            ) : (
                                                <label
                                                    className="form-check-label text-danger"
                                                    htmlhtmlFor="rahpardaznet-settled">تسویه نشده.</label>

                                            )
                                        }
                                    </div>

                                </div>
                                <div className="col-12 input-100 mb-3 pb-2">
                                    <div className="form-group">
                                        <label
                                            htmlhtmlFor="rahpardaznet-description">توضیحات</label>
                                        <textarea className="form-control m-0"
                                            id="rahpardaznet-description"
                                            onChange={(e) => setRk_description(e.target.value)} value={rk_description}>{rk_description}</textarea>
                                    </div>
                                    

                                </div>
                            </div>

                            <div className="row g-2 mb-5">
                                <div className="mx-1 col-6 col-md-12 d-flex justify-content-end me-auto p-0">
                                    <button
                                        tabIndex='17'
                                        onClick={documentUpdateHandler}
                                        type="submit"
                                        className="print-no rahpardaznet-btn">
                                        {'بروزرسانی'}

                                    </button>
                                </div>
                            </div>
                        </>
                    ) : null

                ) : null
            }

        </>
    )
}

export default DocumentEdit;